import * as i0 from "@angular/core";
import * as i1 from "../app/section-search-header/section-search-header.component";
export class CompatSectionSearchHeaderComponent {
    constructor() {
        this.isActive = false;
    }
    ngOnInit() { }
}
CompatSectionSearchHeaderComponent.ɵfac = function CompatSectionSearchHeaderComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || CompatSectionSearchHeaderComponent)(); };
CompatSectionSearchHeaderComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: CompatSectionSearchHeaderComponent, selectors: [["webapp-compat-section-search-header"]], hostVars: 2, hostBindings: function CompatSectionSearchHeaderComponent_HostBindings(rf, ctx) { if (rf & 2) {
        i0.ɵɵclassProp("WebappCompatWrapper", ctx.isActive);
    } }, decls: 1, vars: 0, template: function CompatSectionSearchHeaderComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelement(0, "app-section-search-header");
    } }, dependencies: [i1.SectionSearchHeaderComponent], encapsulation: 2, changeDetection: 0 });
